import { TabProps } from '@chakra-ui/react';
import { Tabs } from '@cmpsr/components';
import { PropsWithChildren } from 'react';

type TabItemProps = PropsWithChildren<{
  isDisabled?: boolean;
  additionalProps?: TabProps;
}>;

export default function TabItem({ children, isDisabled, additionalProps = {} }: TabItemProps) {
  return (
    <Tabs.Item
      width="auto"
      color="text-secondary"
      px={{ base: 2, md: 4 }}
      _selected={{
        textStyle: 'text-body-bold',
        color: 'text-primary',
        borderColor: 'primary-default',
        px: { base: 2, md: 4 },
      }}
      isDisabled={isDisabled}
      {...additionalProps}
    >
      {children}
    </Tabs.Item>
  );
}
